<div fxLayout="row" fxLayoutGap="2px">
  <aside [fxFlex]="isHidden ? '1px' : '200px'" class="side-nav" [class.-hidden]="isHidden">
    <div class="menu-content">
      <ng-content></ng-content>
    </div>
  </aside>

  <div class="toggle" [class.-hidden]="isHidden" (click)="toggleMenu()">
    <ds-icon class="toggle-icon" [svgContent]="toggleIcon"></ds-icon>
  </div>

  <div fxFlex class="content">
    <router-outlet></router-outlet>
  </div>
</div>
